<template>
<div>
  <div class="col-md-12">
    <canvas height="250" id="retention-chart"></canvas>
  </div>
</div>
</template>

<script>
import Chart from 'chart.js'
const axios = require("axios");

export default {
  name: 'bookingSuccess',
  data() {
    return {
      loading: false,
      chartData: [],
      labelData: []
    };
  },
  watch:{
  },
  mounted() {
  },
  created(){
    this.loadData()
  },
  methods:{ 
    async loadData() {
      try {
        var {data} = await axios
          .get(
            "https://api.on-track.in/api/bookingbyTenure",

            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
        )
        var bookingStats = data
        var count1 = 0;
        var count2 = 0;
        var count3 = 0;
        var count4 = 0;
        var count5 = 0;
        var count6 = 0;
        var count7 = 0
        bookingStats.filter((x) => {
          if (Math.round(x.duration / 29) == 1) {
            count1 += x.count;
          } else if (Math.round(x.duration / 29) == 2) {
            count2 += x.count;
          } else if (Math.round(x.duration / 29) == 3) {
            count3 += x.count;
          } else if (Math.round(x.duration / 29) == 4) {
            count4 += x.count;
          } else if (Math.round(x.duration / 29) == 5) {
            count5 += x.count;
          }else if (Math.round(x.duration / 29) == 6) {
            count6 += x.count;
          }
          else if (Math.round(x.duration / 29) > 6) {
            count7 += x.count;
          }
          // return Math.round(x.duration/29) == 1
          });
        this.chartData = [count1, count2, count3, count4, count5, count6, count7 ]
        this.labelData = ["1M", "2M", "3M","4M", "5M", "6M", ">7M"]
      } finally {
        const ctx = document.getElementById('retention-chart');
        var cxRetentionStats = {
          type: 'bar',
          data: {
            labels: this.labelData,
            datasets: [
              {
                data: this.chartData,
                backgroundColor:'rgba(75, 192, 192, 0.2)',
                borderColor:'rgb(54, 162, 235)',
                borderWidth: 2
              },
            ]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(128,0,0,0.04)",
                      drawBorder: false
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(128,0,0,0.04)",
                      drawBorder: false
                  },
                }
              ]
            }
          },
        }
        new Chart(ctx, cxRetentionStats);
      }
    }
  },
  computed:{}
};
</script>

<style>
canvas {
    height: 100%;
    object-fit: contain;
}
</style>